// clientApi.js
// Handles login, heartbeat, and section/interaction-tracking calls for the client-facing
// (gated) side of the site. Separate from adminApi.js since these use a different token/role.

const API_BASE_URL = process.env.REACT_APP_AUTH_SERVICE_URL || "https://deckapi.eilandigital.com";

const TOKEN_KEY = "eilan_client_token";
const EXPIRY_KEY = "eilan_client_expires_at";


function getClientToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function saveClientSession(token, expiresAt) {
  sessionStorage.setItem(TOKEN_KEY, token);
  if (expiresAt) sessionStorage.setItem(EXPIRY_KEY, expiresAt);
}

export function clearClientSession() {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(EXPIRY_KEY);
}

export function isClientLoggedIn() {
  return !!getClientToken();
}

export function getClientExpiryDate() {
  const value = sessionStorage.getItem(EXPIRY_KEY);
  return value ? new Date(value) : null;
}

async function request(path, options = {}) {
  const token = getClientToken();

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  if (!response.ok) {
    let message = "Something went wrong.";
    let code = null;
    try {
      const body = await response.json();
      message = body.message || message;
      code = body.error || null;
    } catch {
      // non-JSON error body - fall back to defaults
    }
    const error = new Error(message);
    error.code = code;
    throw error;
  }

  const text = await response.text();
  return text ? JSON.parse(text) : null;
}

export const clientApi = {
  login: (username, password) =>
    request("/api/auth/user/login", {
      method: "POST",
      body: JSON.stringify({ username, password }),
    }),

  heartbeat: () => request("/api/track/heartbeat", { method: "POST" }),

  sendSectionEvents: (events) =>
    request("/api/track/section", {
      method: "POST",
      body: JSON.stringify({ events }),
    }),

  sendInteractionEvents: (events) =>
    request("/api/track/interaction", {
      method: "POST",
      body: JSON.stringify({ events }),
    }),
};